export interface ProjectGallery {
  id: string;
  name: string;
  category: string;
  location: string;
  year: string;
  description: string;
  mainImage: string;
  images: { src: string; alt: string }[];
}

const baseImages = {
  proj1:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/7fb979999897cc7cff4616165b8033c0.jpeg',
  proj2:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/87887e8950ed6aaacbb6cc0a04d053f4.png',
  proj3:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/8f82f4669eb5b4d96124fdeb799c8953.png',
  proj4:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/123bfccaf4c3b4015249b547a1a2580f.jpeg',
  proj5:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/985d400d5ee649c287b94603e6f90615.png',
  proj6:
    'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/788a471e5a4c646966bd116ad7edfa59.png',
};

export const projectGalleryData: ProjectGallery[] = [
  {
    id: '1',
    name: 'Suíte Aconchego',
    category: 'Residencial',
    location: 'Curitiba, Paraná',
    year: '2023',
    description:
      'Projeto de suíte que valoriza a sensação de acolhimento e tranquilidade, com uma composição equilibrada entre materiais naturais e iluminação suave. A proposta buscou criar um ambiente de descanso atemporal, onde tons neutros, texturas aconchegantes e a presença da luz natural se integram de forma harmoniosa. Elementos como madeira, tecidos leves e iluminação indireta contribuem para uma atmosfera intimista, pensada para promover conforto e bem-estar no cotidiano.',
    mainImage: baseImages.proj1,
    images: [
      { src: baseImages.proj1, alt: 'Sala de estar principal' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/eaede205b0e197a0838fd7c4f7f6020f.jpeg', alt: 'Cozinha integrada' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/c9eeb0857b199e364f04ea48d2cf6b0c.jpeg', alt: 'Suíte master' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/f2fbdad47e89f83e5c6d8b6fca14ae4c.jpeg', alt: 'Sala de jantar' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/17161d1e57bdb6888a9fc89dd8edf610.jpeg', alt: 'Área social' },
      { src: baseImages.proj4, alt: 'Detalhes de acabamento' },
    ],
  },
  {
    id: '2',
    name: 'Residência Solare',
    category: 'Residencial',
    location: 'Curitiba, PR',
    year: '2023',
    description:
      'Um refúgio de serenidade onde cada detalhe celebra a harmonia entre luz, cor e textura. Tons neutros e tecidos suaves abraçam o espaço, convidando ao descanso e à convivência. A madeira, a iluminação indireta e a disposição fluida dos móveis criam uma atmosfera acolhedora, onde cada momento se transforma em experiência de conforto e bem-estar.',
    mainImage: baseImages.proj2,
    images: [
      { src: baseImages.proj2, alt: 'Cozinha gourmet' },
      { src: baseImages.proj5, alt: 'Living com pé-direito duplo' },
      { src: baseImages.proj6, alt: 'Sala de jantar' },
      { src: baseImages.proj1, alt: 'Área íntima' },
      { src: baseImages.proj3, alt: 'Suíte' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/3648aed1cbf986ac616409d5fd084065.png', alt: 'Varanda' },
    ],
  },
  {
    id: '3',
    name: 'Home Office Essência',
    category: 'Residencial',
    location: 'Curitiba, Paraná',
    year: '2024',
    description:
      'Ambiente pensado para unir produtividade e acolhimento em uma atmosfera sofisticada e serena. A marcenaria em madeira natural envolve o espaço de forma elegante, criando unidade visual entre teto, painel e bancada. A iluminação indireta valoriza as texturas e traz aconchego, enquanto os tons neutros e os elementos orgânicos transformam o home office em um refúgio contemporâneo e funcional.',
    mainImage: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/cb70513cab1eb12f6a73d35d52a38f7f.jpeg',
    images: [
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/cb70513cab1eb12f6a73d35d52a38f7f.jpeg', alt: 'Suíte master' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/e3d7b60adf5e772a3349343afefff8ba.jpeg', alt: 'Sala de estar' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/19eff6571c23cfbe10ca62d9e3d0d13f.jpeg', alt: 'Sala de jantar' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/3309caf64b3add41b32cd421105b8537.jpeg', alt: 'Cozinha' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/8573bc9bceed7b9f60f134269873a40f.jpeg', alt: 'Hall de entrada' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/614d7aeb9039d3bfacbc5bddb26e22a9.png', alt: 'Escritório' },
    ],
  },
  {
    id: '4',
    name: 'Lavabo Duna',
    category: 'Residencial',
    location: 'Curitiba, Paraná',
    year: '2023',
    description:
      'Onde a beleza natural da pedra e da madeira se encontra com a suavidade da luz difusa. O espelho de formas orgânicas reflete a calma do ambiente, enquanto cada detalhe minimalista transforma o cotidiano em um ritual de tranquilidade e cuidado.',
    mainImage: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/0f9f3b3599c3d1af99023842010ea0f1.png',
    images: [
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/fe78a4c0decd0bac031698f0096e57b4.png', alt: 'Recepção' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/0f9f3b3599c3d1af99023842010ea0f1.png', alt: 'Sala de reuniões' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/8662d36525fb2794ebae9d48784da93e.png', alt: 'Copa' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/a7dc9761d14124bbf9b3bbc3a937b9ae.png', alt: 'Área colaborativa' },
    ],
  },
  {
    id: '5',
    name: 'Residencial B\u0026G',
    category: 'Residencial',
    location: 'Almirante Tamandaré, Paraná',
    year: '2022',
    description:
      'Projeto de fachada com linhas retas e volumetria marcante, traduzindo modernidade e imponência de forma equilibrada. A combinação entre tons sóbrios, grandes aberturas em vidro e paisagismo minimalista cria uma estética elegante e atemporal. Os elementos horizontais reforçam a sensação de amplitude e privacidade, resultando em uma residência sofisticada e acolhedora desde o primeiro olhar.',
    mainImage: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/06c02e0d29228897efca26bb68deb17b.jpeg',
    images: [
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/584820b9ca9b303545b90e66831173e3.jpeg', alt: 'Living com pé-direito duplo' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/4ddee350cbebccffbd596cfe97333ab9.jpeg', alt: 'Cozinha americana' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/a450f3da125ffcb0e017a71ad4e96dea.png', alt: 'Mezanino' },
    ],
  },
  {
    id: '6',
    name: 'Refúgio Contemporâneo',
    category: 'Residencial',
    location: 'Matinhos, Paraná',
    year: '2026',
    description:
      'Projetado para valorizar a convivência e a fluidez entre os ambientes, este espaço integra living, jantar e cozinha em uma composição contemporânea e acolhedora. A marcenaria em madeira natural contrasta suavemente com os acabamentos claros, trazendo equilíbrio e sofisticação ao projeto. A ilha central se destaca como ponto de encontro do ambiente, unindo funcionalidade e elegância, enquanto a iluminação natural amplia a sensação de conforto e leveza. O resultado é um espaço atemporal, pensado para receber e viver com praticidade e estilo.',
    mainImage: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/83532e3d90dbfc9b4eaddf7de7e5812e.jpeg',
    images: [
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/69ced12a86df3678e6f1d94f06ecffb7.jpeg', alt: 'Sala de jantar' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/8a35abb74b2ce7672d06d55f9a72b47d.jpeg', alt: 'Sala de estar' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/c94076bab7c5d66c4b785b216a7a073b.jpeg', alt: 'Suíte' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/1d441b72d15f92a68e1a998d58700524.jpeg', alt: 'Cozinha' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/9a6c27514d6fb2f16cca4aea2c9b41fc.jpeg', alt: 'Varanda' },
      { src: 'https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/21c7b5f9419ae1ebc6080ef9d2ab8896.jpeg', alt: 'Hall' },
    ],
  },
];

export function getProjectById(id: string): ProjectGallery | undefined {
  return projectGalleryData.find((p) => p.id === id);
}
